export default function ContactHero() {
  return (
    <section className="relative bg-background-50 pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://readdy.ai/api/search-image?query=Modern%20bright%20office%20desk%20with%20laptop%20and%20notebook%2C%20clean%20white%20workspace%2C%20soft%20natural%20daylight%20from%20window%2C%20professional%20workspace%20atmosphere%2C%20clean%20minimal%20composition%2C%20bright%20tones%20with%20warm%20accents%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=contact-hero-bg-light&orientation=landscape')] bg-cover bg-center opacity-10" />
      <div className="absolute inset-0 bg-gradient-to-b from-background-100/60 via-background-50/80 to-background-50" />

      <div className="relative w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
            <i className="ri-mail-send-line text-sm w-4 h-4 flex items-center justify-center" />
            Contacto
          </div>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-950 mb-5">
            Importe Demulsificante{' '}
            <span className="text-primary-500">Desde China a Venezuela</span>
          </h1>
          <p className="text-foreground-600 text-sm md:text-lg max-w-3xl mx-auto mb-8">
            Cuéntenos sobre sus operaciones y requerimientos. Nuestro equipo le asesorará 
            en la importación de demulsificantes de Rixin Corp, con entrega puesta en Venezuela.
          </p>
        </div>
      </div>
    </section>
  );
}